import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navigation from "../../Navbar";
import HeroSectionVKIVIU from "./HeroSectionVKIVIU";
import DefinitionVKIVKIU from "./DefinitionVKIVIU";
import BenefitVKIVIU from "./BenefitVKIVIU";
import LegalBasisVKIVIU from "./LegalBasisVKIVIU";
import FlowVKIVIU from "./FlowVKIVIU";
import ContactUs from "../tkdn/ContactUs";
function VKIVIU() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const contactUs = [
    {
      name: "Marketing VKI",
      email: "cs.vki@anindya.biz",
      phone: "",
    },
    {
      name: "Marketing VIU",
      email: "cs.viu@anindya.biz",
      phone: "",
    },
    {
      name: "Maura Iskandar",
      email: "mauranyssa@anindya.biz",
      phone: "+62-878-2175-4269",
    },
    {
      name: "Rio Wardhana",
      email: "rio.wardhana_lsi@anindya.biz",
      phone: "+62-821-1171-3224",
    },
  ];
  return (
    <>
      <Navigation />
      <HeroSectionVKIVIU />
      <DefinitionVKIVKIU />
      <div style={{ backgroundColor: "#F2F2F2" }}>
        <BenefitVKIVIU />
      </div>
      <LegalBasisVKIVIU />

      <div style={{ backgroundColor: "#F2F2F2" }}>
        {" "}
        <FlowVKIVIU />
      </div>
      <ContactUs data={contactUs} sectionTitle={"contact_title"} />
    </>
  );
}

export default VKIVIU;
